import React from 'react';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';

const ThemeContainer = ({ children }) => {
  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MUIDataTableBodyCell: {
          root: {},
        },
        MuiIconButton: {
          sizeSmall: {
            // Adjust spacing to reach minimal touch target hitbox
            marginLeft: 4,
            marginRight: 4,
            padding: 12,
          },
        },
      },
      props: {
        MuiTable: {
          size: 'small',
        },
      },
    });
  return <ThemeProvider theme={getMuiTheme()}>{children}</ThemeProvider>;
};

export default ThemeContainer;
